/**
 * Configuration déclarative pour l'entité Product
 * Source unique de vérité pour tous les champs de Product
 */

import type { Product } from '../../types/product';
import { defineEntityConfig } from '../../lib/entity-config';
import { parseFrenchDate, generateSlug } from '../../lib/csv-import';

export const PRODUCT_CONFIG = defineEntityConfig<Product>({
  entityName: 'produit',
  entityNamePlural: 'produits',

  fields: {
    name: {
      key: 'name',
      label: 'Produit',
      type: 'text',
      required: true,
      unique: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
      importValidation: (value) => {
        if (typeof value !== 'string') return 'Le nom doit être une chaîne de caractères';
        if (value.length < 3) return 'Le nom doit contenir au moins 3 caractères';
        return true;
      },
    },

    start_date: {
      key: 'start_date',
      label: 'Date de début',
      type: 'date',
      sortable: true,
      editable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
      description: 'Format: JJ/MM/AAAA',
      exportTransform: (value: string) =>
        value ? new Date(value).toLocaleDateString('fr-FR') : '',
      importTransform: (value: string) => parseFrenchDate(value),
    },

    end_date: {
      key: 'end_date',
      label: 'Date de fin',
      type: 'date',
      sortable: true,
      editable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 200,
      description: 'Format: JJ/MM/AAAA',
      exportTransform: (value: string) =>
        value ? new Date(value).toLocaleDateString('fr-FR') : '',
      importTransform: (value: string) => parseFrenchDate(value),
    },

    slug: {
      key: 'slug',
      label: 'Slug',
      type: 'text',
      showInTable: false,
      hiddenInColumnSelector: true, // Champ technique
      showInFilters: false,
      exportable: false,
      importable: false,
    },
  },
});

/**
 * Fonction helper pour les derived fields (slug)
 */
export function getProductDerivedFields() {
  return {
    slug: (data: Partial<Product>) => (data.name ? generateSlug(data.name as string) : ''),
  };
}
